<p-divider align="left" >
  <b style="background-color: var(--surface-ground);">Editors</b>
</p-divider>
<div class="text-500 mb-3 font-medium text-sm">
  Quick access to pre-configured item editing tools assigned to you
</div>
<div class="grid">
  <div class="col-12 lg:col-4 xl:col-3" *ngFor="let editor of myEditors">
    <div class="card mb-0 editor-card" style="cursor: pointer;" (click)="gotoEditor(editor.id)">
      <div class="flex flex-column align-items-center justify-content-center mb-3">
        <i class="pi pi-pen-to-square" style="font-size: 1.5rem;  margin-bottom: 0.5rem;"></i>
        <div style="white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;"> {{editor.name}}
        </div>
      </div>
      
    </div>
  </div>
  <div class="col-12 lg:col-4 xl:col-3" *ngIf="hasEditorPermission">
    <div class="card mb-0" style="cursor: pointer; border: 4px dashed var(--surface-border);" (click)="gotoEditorSettings()">
      <div class="flex flex-column align-items-center justify-content-center mb-3">
        <i class="pi pi-plus-circle" style="font-size: 1.5rem; color: var(--primary-color); margin-bottom: 0.5rem;"></i>
        <div style="color: var(--primary-color); font-weight: 500;">Add New Editor</div>
      </div>
    </div>
  </div>
</div>
